import { AirVent, Car, Wifi } from 'lucide-react'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { FaSwimmingPool } from "react-icons/fa";
import { FaTv } from "react-icons/fa";
import SliderRoom from './SliderRoom';
export default function RoomCard() {
  let [data, setData] = useState([])
  let [room, setRoom] = useState([])
  let [checkIn, setCheckIn] = useState()
  let [checkOut, setCheckOut] = useState()
  let [duplicaterooms, setDuplicaterooms] = useState([])
  let [selectedRoom, setSelectedRoom] = useState(null)

  let { _id } = useParams()
  async function getApiData(data) {
    let response = await fetch("https://vhotelbackend.onrender.com/api/roomcart", {
      method: "GET",
      headers: {
        "content-type": "application/json",
        "authorization": localStorage.getItem("token")
      }
    })

    response = await response.json()
    if (response.result === "Done") {

      setData(response.data)
      setDuplicaterooms(response.data)
    }
    else
      setData([])

  }
  useEffect(() => {
    getApiData()
  }, [data.length])
  return (
    <>

      <Helmet>
        <title>Hotels Near IGI Airport | V Hotel The Grand Shoba</title>
        <meta
          name="description"
          content="Discover comfort and convenience at V Hotel The Grand Shoba, one of the finest hotels near IGI Airport with modern rooms, dining, and excellent hospitality"
        />
        <meta
          name="keywords"
          content="Hotels Near IGI Airport"
        />
       
        
             <link rel="canonical" href="https://www.vhotelthegrandshoba.com/booking" />
      </Helmet>
      <SliderRoom />

      <h1 className='text-center' style={{color:"#856a2b", fontFamily:"Cinzel" , paddingTop:"20px", paddingBottom:"25px"}}>Hotels Near IGI Airport</h1>

      <div className="roomcard-desk">
        {
          data.map((item, index) => {
            return (
              <div className="row booking-room mt-5" key={index}>
                <div className="col-md-4 col-12" >
                  <div className='booking-room-img-div'>
                    <img src={`https://vhotelbackend.onrender.com${item.pic[1]}`} loading="lazy" title={`V_Hotel_the_grnad_shoba_${item.name}`} className='booking-room-img' alt="card-image-room" />
                  </div>

                </div>
                <div className="col-md-8 booking-room-description  ">
                  <h3 className='booking-room-h3 mt-2 '>{item.name}</h3>
                  <p className="mb-0 text-muted">{item.message}</p>
                  <div className="card-room-service d-flex mt-2 mb-2">
                    <div className="wifi me-5">
                      <Wifi /> <span>Wi-Fi</span>
                    </div>
                    <div className="wifi me-5" >
                      <Car /> <span>Parking</span>
                    </div>
                    <div className="wifi me-5">
                      <FaTv /> <span>T.V</span>
                    </div>
                    <div className="wifi me-5">
                      <FaSwimmingPool className='me-2' /><span>Swimming Pool</span>
                    </div>
                  </div>
                  <div className="booking-room-type">
                    <h6 className='text-success'> Room Available</h6>
                    <h6>Type: {item.name}</h6>
                    <h6 className='text-success fw-bolder'> &#8377; {item.finalPrice}/night</h6>
                  </div>
                  <div className="room-card-btn  gap-10">
                    {/* <Link > <button  className='booking-card-room-btn' data-bs-toggle="modal" data-bs-target="#exampleModal">VEIW</button> </Link> */}
                    <button
                      className='booking-card-room-btn'
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() => setSelectedRoom(item)}  // yeh line important hai
                    >
                      VIEW
                    </button>



                    <Link to={`/check-availability/${item._id}`} title='check-availability'> <button className='booking-card-room-btn1'>BOOK NOW</button> </Link>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>





      {/* mobile screen card */}
      <div className="roomcard-mobile">

        {
          data?.map((item, index) => {
            return (
              <div key={index} className="mobile-room-card d-block d-sm-none shadow-sm p-2 mb-3 rounded border">
                {/* 1st div - Image */}
                <div className="room-img mb-2">
                  <img src={`https://vhotelbackend.onrender.com${item.pic[1]}`} loading="lazy" title={`V_Hotel_the_grnad_shoba_${item.name}`} alt={item.name} className="w-100 h-100 object-fit-cover rounded" />
                </div>

                {/* 2nd div - Title and Description */}
                <div className="mb-2">
                  <h5 className="mb-1 booking-room-mob-h5 text-center">{item.name}</h5>
                  <p className="mb-0 text-muted mt-2">{data.message}</p>
                </div>

                {/* 3rd div - Left and Right Span */}
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-success fw-bold">Room Available</span>
                  <span className="">Type: {item.name}</span>
                  <span className="fw-bold text-success">&#8377;{item.price} /night</span>
                </div>

                {/* 4th div - Centered Button */}
                <div className="room-card-btn  gap-10">
                  {/* <Link > <button className='booking-card-room-btn' data-bs-toggle="modal" data-bs-target="#exampleModal">VEIW</button> </Link> */}
                  <button
                    className='booking-card-room-btn'
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    onClick={() => setSelectedRoom(item)}  // yeh line important hai
                  >
                    VIEW
                  </button>



                  <Link to={`/check-availability/${item._id}`}> <button className='booking-card-room-btn1'>BOOK NOW</button> </Link>
                </div>
              </div>
            )
          })
        }
      </div>






      {/* modal  bootsrap 5.3.3*/}
      <div className="modal fade" id="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog w-100">
          <div className="modal-content">
            <div className="modal-header m-auto ">
              {/* <h1 className="modal-title fs-5  mx-5" id="exampleModalLabel">{data[0].name}</h1> */}
              <button type="button" className="btn-close  float-end" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">

              <div id="carouselExampleAutoplaying" className="carousel slide" data-bs-ride="carousel">
                {/* <div className="carousel-inner"> */}

                  {/* <img src={`/${data.pic}`} className="d-block w-100" alt="..." /> */}
                  <div className="carousel-inner">
                    {
                      selectedRoom?.pic?.map((img, index) => (
                        <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
                          <img src={`https://vhotelbackend.onrender.com${img}`} loading="lazy" className="d-block w-100" alt={`room image ${index}`} />
                        </div>
                      ))
                    }

                    
                  </div>
        
              
                <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
                  <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
                  <span className="carousel-control-next-icon" aria-hidden="true"></span>
                  <span className="visually-hidden">Next</span>
                </button>
              </div>

              <p className="mb-0 text-muted mt-2">{selectedRoom?.message}</p>
 

              <div className="realted-room-amenities">
                <span className=''>Amenities</span>
                <div className="row">
                  <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                      <div className="simple-room-service-icon">
                        <img src="/images/air-conditionar.svg" loading="lazy" width='50' height={50} alt="v-hotel-shoba-ac-image" />
                      </div>
                      <div className="simple-room-service-name">
                        <p>Air-Conditioning</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                      <div className="simple-room-service-icon">
                        <img src="/images/wifi.svg" width='50'  loading="lazy" height={50} alt="v-hotel-shoba-wifi-image" />
                      </div>
                      <div className="simple-room-service-name">
                        <p> Wi-Fi</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                      <div className="simple-room-service-icon">
                        <img src="/images/bed.svg" loading="lazy" width='50' height={50} alt="v-hotel-shoba-bed-image" />
                      </div>
                      <div className="simple-room-service-name">
                        <p>King/Twin Bed</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                      <div className="simple-room-service-icon">
                        <img src="/images/tv.svg" width='50' loading="lazy" height={50} alt="v-hotel-shoba-TV-image" />
                      </div>
                      <div className="simple-room-service-name">
                        <p>Television </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                      <div className="simple-room-service-icon">
                        <img src="/images/tea.svg" width='50' loading="lazy" height={50} alt="v-hotel-shoba-coffee-maker-image" />
                      </div>
                      <div className="simple-room-service-name">
                        <p>Tea & Coffee Maker</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="simple-room-service d-flex">
                      <div className="simple-room-service-icon">
                        <img src="/images/bar.svg" width='50' loading="lazy" height={50} alt="v-hotel-shoba-bar-image" />
                      </div>
                      <div className="simple-room-service-name">
                        <p>Minibar</p>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}
